export const APPLICATION_IDS = {
    DATA_ANALYSIS: "data_analysis",
    SQL_ANALYSIS: "sql_analysis",
    CUSTOM_ANALYSIS: "custom_analysis",
    AUDIENCE_OVERLAP: "audience_overlap_analysis",
    LOOKALIKE_MODELING: "audience_lookalike_modeling",
    ADVANCE_OVERLAP: "overlap_analysis",
    REACH_AND_FREQUENCY: "reach_and_frequency",
    ATTRIBUTION_ANALYSIS: "attribution_analysis",
    CONVERSION_TRACKING: "conversion_tracking",
    INVENTORY_FORCASTING_PLANNING: "inventory_forecasting_and_planning",
    CREATIVE_PERFORMANCE: "creative_performance",
    AUDIENCE_OVERLAP_LIST: "audience_overlap_analysis_list",
    AUDIENCE_OVERLAP_AGGREGATION: "audience_overlap_analysis_aggregation",
};

export const MENU_IDS = {
    MENU_ID_CLEANROOMS: "cleanrooms",
    MENU_ID_CONNECTORS: "connector",
    MENU_ID_DEVELOPER_EDITION: "developer_edition",
    MENU_ID_ACCOUNT: "Account",
    MENU_ID_ANALYSIS: "analysis",
    MENU_ID_ACCOUNT_GOVERNANCE: "account-governance",
    MENU_ID_ACCOUNT_BILLING: "account-billing",
    MENU_ID_LOGOUT: "logout",
    MENU_ID_HELP_CENTER: "help",
    MENU_ID_ACCOUNT_PROFILE: "profile",
    MENU_ID_ADMIN: "admin",
    MENU_ID_COLLABORATORS: "collaborators",
};

export const EDITION = {
    STANDARD: "standard",
    ENTERPRISE: "enterprise",
    UNKNOWN: "unknown",
};

export const MARKETING_ROLES = {
    PUBLISHER: "PUBLISHER",
    ADVERTISER: "ADVERTISER",
};

export const APP_CATEGORY_COLOR = {
    Horizontal: "#F6E0BF",
    "Advertising & Marketing": "#DAE6FE",
    "Financial Services": "#D4F6BF",
    "Healthcare & Life Science": "#F6C2BF",
};

export const APPLICATION_NAMES = {
    LOOKALIKE_MODELING: "Audience Lookalike Modeling",
    CONVERSION_TRACKING: "Conversion Tracking",
};

export const COLORS = {
    BLACK: "#000000",
    BALCK2: "#090932",
    LINK: "#1A6CE7",
    GRAY: "#656C7B",
    TEXT_DISABLED: "#CCCCCC",
    TEXT_DARK: "#424242",
};

export const GOVERNANCE_COLUMNS = {
    CLEANROOM_NAME: "Clean Room Name",
    ACCOUNT_LOCATOR: "Account Locator",
    ENCRYPTED_USER_ID: "Encrypted User ID",
    ANALYSIS_TEMPLATE: "Analysis & Query Template",
    ANALYSIS_EXECUTED_ON: "Run Date",
    NO_OF_ANALYSIS_EXECUTED: "Run Count",
};

export const BILLING_COLUMNS = {
    ANALYSIS_NAME: "Analysis Template",
    CLEANROOM_NAME: "Clean Room Name",
    EXECUTED_DATE: "Run Date",
    COMPUTE_CREDITS: "Compute Credits",
    DOLLARS: "Dollars ($)",
    SAMOOHA_FEES: "Snowflake Data Clean Rooms App Fees ($)",
};

export const BILLING_CHARTS_OPTIONS = {
    EXECUTION_DATE: "Run Date",
    DAYS_COUNT: "Day ount",
    COMPUTE_CREDITS: "Compute Credits",
    COST: "Cost",
};

export const REACH_AND_FREQUENCY_CAMPAIGN_CHART_OPTIONS = {
    IMPRESSIONS_COUNT: "Impressions Count",
    IMPRESSIONS_COUNT_LABEL_PREFIX: "Impressions Count of",
    AUDIENCE_REACH: "Audience Reach",
    REACH: "Reach",
    CAMPAIGN_NAME: "Campaign Name",
    FREQUENCY: "Frequency",
};

export const REACH_AND_FREQUENCY_CAMPAIGN_CHART_COLORS = {
    SPECIFIC_CAMPAIGN: "#1098AD",
    TOTAL_CAMPAIGN: "#E1009C",
    CAMPAIGN_REACH_FREQUENCY: "#FEC000",
};

export const CAPI_STATUS = {
    FAILED: "Failed",
    SUCCESS: "Sucess",
};

export const CLEANROOM_TYPES = {
    SAMOOHA: "SAMOOHA",
    SNOWFLAKE: "SNOWFLAKE",
    META_CAPI: "META_CAPI",
    AMAZON_AMC: "AMAZON_AMC",
    AMC: "AMC",
    ADH: "ADH",
    NATIVE: "NATIVE",
    AWS_CLEANROOM: "AWS_CLEANROOM",
    DEV_MODE: "SNOWFLAKE_DEV_MODE",
};

export const CLEANROOM_TYPES_CONFIG = {
    META_CAPI: {
        logo: "static/images/icons/meta.svg",
        name: "Meta",
    },
    AMAZON_AMC: {
        logo: "static/images/icons/amazon_icon.svg",
        name: "Amazon",
    },
    AMC: {
        logo: "static/images/icons/amazon_icon.svg",
        name: CLEANROOM_TYPES.AMC,
        title: "Amazon Marketing Cloud",
    },
    ADH: {
        logo: "static/images/icons/ads_data_hub.svg",
        name: CLEANROOM_TYPES.ADH,
        title: "Ads Data Hub",
    },
    SAMOOHA: {
        logo: "static/images/samooha_small.png",
        name: "Samooha",
    },
    NATIVE: {
        logo: "static/images/samooha_small.png",
        name: "Samooha",
    },
    AWS_CLEANROOM: {
        logo: "static/images/icons/aws_28x32.svg",
        name: "Amazon",
    },
    SNOWFLAKE: {
        logo: "static/images/icons/install_snowflake.svg",
        name: "Snowflake",
    },
    SNOWFLAKE_DEV_MODE: {
        logo: "static/images/icons/install_snowflake.svg",
        name: "Snowflake",
    },
};

export const FIVETRAN_CONNECTOR_STATUS = {
    BROKEN: "broken",
    INCOMPLETE: "incomplete",
    CONNECTED: "connected",
    PENDING: "pending",
    FAILED: "failed",
    SUCCESS: "success",
};

export const AMC_CONNECTOR_STATUS = {
    BROKEN: "broken",
    INCOMPLETE: "incomplete",
    CONNECTED: "connected",
    PENDING: "pending",
    FAILED: "failed",
    SUCCESS: "success",
};

export const BILLING_CHARTS_TYPE = {
    DOLLAR: "Dollar ($)",
    CREDIT: "Credit",
};

export const CONNECTOR_SUCCESS_FAIL_MEG = {
    CONNECTOR_STATUS_SUCCESS_MESSAGE: "Authenticated",
    CONNECTOR_STATUS_FAIL_MESSAGE: "Failed",
    CONNECTOR_STATUS_CONFIGURED_MESSAGE: "Configured",
    CONNECTOR_STATUS_PENDING_MESSAGE: "Pending",
    CONNECTOR_STATUS_REVOKED_MESSAGE: "Access Revoked",
};

export const ThirdPartyIdentityProvider = {
    LIVERAMP_RAMPID_TRANSCODING: "LIVERAMP_RAMPID_TRANSCODING",
    LIVERAMP_IDENTITY_RESOLUTION: "LIVERAMP_IDENTITY_RESOLUTION",
    LIVERAMP_IDENTITY_SOLUTION: "LIVERAMP_IDENTITY_SOLUTION",
    ACXIOM_IDENTITY_GENERATION: "ACXIOM_IDENTITY_GENERATION",
    ACXIOM_TRANSCODING: "ACXIOM_TRANSCODING",
    TRANSUNION_IDENTITY_GENERATION: "TRANSUNION_IDENTITY_GENERATION",
    TRADE_DESK: "trade_desk",
    GOOGLE_PAIR_DV360: "GOOGLE_PAIR_DV360",
    MERKURY_IDENTITY_GENERATION: "MERKURY_IDENTITY_GENERATION",
    UID_2: "UID_2.0",
};

export const DataEnrichment = {
    EXPERIAN: "experian",
};

export const extractSelectionFromFilters = (selectedOptions) => {
    if (Array.isArray(selectedOptions)) {
        let options = selectedOptions.reduce(
            (accumulator, option) => accumulator.concat(option.value),
            [],
        );
        return options;
    }
    return selectedOptions.value;
};

export const COLUMNS = {
    TIMESTAMP: "TIMESTAMP",
    DATE: "DATE",
    HOUR: "HOUR",
    ALL: "All",
    GROUP_BY: "GROUP BY",
    AGGREGATE: "AGGREGATE",
    FILTER_AND_GROUP_BY: "FILTER_AND_GROUP_BY",
    CAMPAIGN_ID: "CAMPAIGN_ID",
    UNIQUE_ID_COLUMN: "UNIQUE_ID_COLUMN",
    CHANNEL_COLUMN: "CHANNEL_COLUMN",
    TRAIN_ON_COLUMN: "TRAIN_ON_COLUMN",
    CREATIVE_ID_COLUMN: "CREATIVE_ID_COLUMN",
    ACTIVATION_ID_COLUMN: "ACTIVATION_ID_COLUMN",
};

export const AUTORUN_INTERVALS = {
    0: "Off",
    1: "Hourly",
    2: "Daily",
    3: "Weekly",
};

export enum LOADER_ID {
    AUDIENCE_OVERLAP = "AUDIENCE_OVERLAP",
    AUDIENCE_OVERLAP_MULTI = "AUDIENCE_OVERLAP_MULTI",
    LOOKALIKE_MODELLING = "LOOKALIKE_MODELLING",
    CONVERSION_TRACKING = "CONVERSION_TRACKING",
    AMC_QUERY_CONVERSION_TRACKING = "AMC_QUERY_CONVERSION_TRACKING",
    CONVERSION_TRACKING_MULTI = "CONVERSION_TRACKING_MULTI",
    REACH_AND_FREQUENCY = "REACH_AND_FREQUENCY",
    AMC_QUERY_REACH_AND_FREQUENCY = "AMC_QUERY_REACH_AND_FREQUENCY",
    INVENTORY_FORCASTING_PLANNING = "INVENTORY_FORCASTING_PLANNING",
    ADVANCED_OVERLAP = "ADVANCED_OVERLAP",
    DATA_ANALYSIS = "DATA_ANALYSIS",
    CUSTOM_ANALYSIS = "CUSTOM_ANALYSIS",
    GENERIC = "GENERIC",
    CONFIGURE_CONNECTOR = "CONFIGURE_CONNECTOR",
    ADD_ACCOUNT = "ADD_ACCOUNT",
    REFRESH_DATABASE_TABLES = "REFRESH_DATABASE_TABLES",
    SYNCING_DATABASES = "SYNCING_DATABASES",
}

export const EXTERNAL_LINKS = {
    SAMOOHA_TOS:
        "https://www.snowflake.com/legal/snowflake-data-clean-rooms-terms",
    SNOWFLAKE_APP: "https://app.snowflake.com/",
    LEARN_MORE: "https://other-docs.snowflake.com/cleanrooms/introduction",
    GETTING_STARTED: "https://other-docs.snowflake.com/cleanrooms/introduction",
    WAREHOUSE_DOCUMENTATION:
        "https://docs.snowflake.com/en/user-guide/warehouses-overview",
    DEVELOPER_EDITION_LEARN_MORE:
        "https://other-docs.snowflake.com/cleanrooms/developer-introduction",
    DEVELOPER_EDITION: "https://app.snowflake.com/worksheets",
    DEVELOPER_EDITION_UI_FORM_LEARN_MORE:
        "https://docs.snowflake.com/en/user-guide/cleanrooms/demo-flows/register-cleanroom-in-ui",
    EXTERNAL_DATA_AWS:
        "https://other-docs.snowflake.com/cleanrooms/external-data-aws",
    EXTERNAL_DATA_GCP:
        "https://other-docs.snowflake.com/cleanrooms/external-data-gcp",
    EXTERNAL_DATA_AZURE:
        "https://docs.snowflake.com/en/user-guide/cleanrooms/external-data-azure#connect-to-azure-blob-storage",
    MANAGED_ACCOUNTS:
        "https://docs.snowflake.com/alias/cleanrooms/managed-accounts",
    CLEANROOM_LEARN_MORE:
        "https://other-docs.snowflake.com/cleanrooms/tutorials/cleanroom-web-app-tutorial",
    PC_EOL_LEARN_MORE:
        "https://docs.snowflake.com/en/user-guide/cleanrooms/pc-eol",
    INSTALL_CLEANROOM_ADMIN_PAGE:
        "https://docs.snowflake.com/user-guide/cleanrooms/installing-dcr#label-dcr-install-clean-rooms-ui-step",
    SNOWFLAKE_AUTHENTICATION_POLICIES:
        "https://docs.snowflake.com/en/user-guide/authentication-policies",
    TRANSUNION_DOCUMENTATION_LINK:
        "https://docs.snowflake.com/alias/cleanrooms/transunion-connector-admin",
    ACXIOM_IDENTITY_GENERATION_DOCUMENTATION_LINK:
        "https://docs.snowflake.com/en/user-guide/cleanrooms/connector-identity#acxiom-real-id-connector",
    MERKURY_IDENTITY_GENERATION_DOCUMENTATION_LINK:
        "https://docs.snowflake.com/en/user-guide/cleanrooms/connector-identity#merkury-identity-connector",
    ACXIOM_TRANSCODING_DOCUMENTATION_LINK:
        "https://docs.snowflake.com/en/user-guide/cleanrooms/connector-identity#acxiom-real-id-transcoding-connector",
    SQL_QUERY_TEMPLATE_DOCUMENTATION_LINK:
        "https://docs.snowflake.com/alias/cleanrooms/sql-template",
    YAHOO_ACTIVATION_DOCUMENTATION_LINK:
        "https://docs.snowflake.com/en/user-guide/cleanrooms/activation-yahoo-dsp",
    OVERLAP_STATS_DOCUMENTATION_LINK:
        "https://docs.snowflake.com/en/user-guide/cleanrooms/web-app-working#view-details-about-clean-room",
    DV_360_DATA_CONSENT_LINK:
        "https://docs.snowflake.com/en/user-guide/cleanrooms/connector-activation",
    DV_360_CMU_CONNECTOR_LINK:
        "https://docs.snowflake.com/en/user-guide/cleanrooms/connector-activation#label-cleanrooms-activation-admin-google-dv360",
    DV_360_PAIR_CONNECTOR_LINK:
        "https://docs.snowflake.com/en/user-guide/cleanrooms/google-pair",
    LIVERAMP_IDENITY_SOLUTION_CONNECTOR_DOCUMENTATION_LINK:
        "https://docs.snowflake.com/en/user-guide/cleanrooms/connector-identity#liveramp-identity-resolution-connector",
    GET_STARTED_WITH_SNOWFLAKE_DCR:
        "https://docs.snowflake.com/en/user-guide/cleanrooms/getting-started",
    USE_CASES:
        "https://docs.snowflake.com/en/user-guide/cleanrooms/web-app-sql-template",
    THIRD_PARTY_CONNECTORS:
        "https://docs.snowflake.com/en/user-guide/cleanrooms/external-data-aws",
    SECURITY_AND_PRIVACY:
        "https://docs.snowflake.com/en/user-guide/cleanrooms/differential-privacy",
    // TODO: Add link to freeform sql in snowsight
    FREEFORM_SQL_IN_SNOWFLAKE_SIGHT:
        "https://docs.snowflake.com/en/user-guide/cleanrooms/google-pair",
    SNOWFLAKE_AUTHENTICATION_DOCUMENTATION:
        "https://docs.snowflake.com/en/user-guide/cleanrooms/update-to-oauth",
    SNOWFLAKE_SERVICE_USERNAME_DOCUMENTATION:
        "https://docs.snowflake.com/en/user-guide/cleanrooms/installing-dcr#enable-the-clean-rooms-ui",
    INTERNAL_TEST_CLEAN_ROOM_LEARN_MORE:
        "http://docs.snowflake.com/alias/cleanrooms/ui-internal-test-tutorial",
    DEV_EDITION_TEMPLATE_LEARN_MORE:
        "https://docs.snowflake.com/alias/cleanrooms/sample-templates",
    DEV_EDITION_SNOWSIGHT_LINK_OUT: "https://app.snowflake.com",
};

export const EXTERNAL_EMAILS = {
    TRANSUNION_SUPPORT: "PDLtucloudappsupport@transunion.com",
    ACXIOM_SUPPORT: "accrealid@acxiom.com",
    MERKURY_SUPPORT: "IDConnector@dentsu.com",
    LIVERAMP_SUPPORT: "liverampsnowflakesupport@liveramp.com",
    UID_2_SUPPORT: "snflUID2techsupport@thetradedesk.com",
    LIVERAMP_SOLUTION_SUPPORT: "snowflake@liveramp.com",
};

export enum ACTIVATION_CONNECTOR_ID {
    CUSTOM_AD_SERVER = "CUSTOM_AD_SERVER",
    EXPORT_TO_PROVIDER = "EXPORT_TO_PROVIDER",
    EXPORT_TO_CONSUMER = "EXPORT_TO_CONSUMER",
    THE_TRADE_DESK = "THE_TRADE_DESK",
    THE_TRADE_DESK_CRM = "THE_TRADE_DESK_CRM",
    YAHOO_ACTIVATION = "YAHOO_ACTIVATION",
    GOOGLE_ADS_MANAGER = "GOOGLE_ADS_MANAGER",
    GOOGLE_DV_360 = "GOOGLE_DV_360",
    GOOGLE_DV_360_PAIR = "GOOGLE_DV_360_PAIR",
    FACEBOOK_ADS_MANAGER = "FACEBOOK_ADS_MANAGER",
    LIVERAMP_CONNECT = "LIVERAMP_CONNECT",
}

export const ID_HAS_ASTERISK: any = [
    ACTIVATION_CONNECTOR_ID.EXPORT_TO_CONSUMER,
    ACTIVATION_CONNECTOR_ID.LIVERAMP_CONNECT,
];

/**
 * Returns Description to be shown for an ID Provider
 * @TODO: Should be consumed from BE later
 * @param dataProviderId
 * @returns
 */
export function getIdProviderDescription(dataProviderId) {
    switch (dataProviderId) {
        case ThirdPartyIdentityProvider.TRADE_DESK:
            return "UID 2.0 converts email and phone keys into encrypted and hashed IDs serving as an identity solution for publishers and advertisers.";
        case ThirdPartyIdentityProvider.TRANSUNION_IDENTITY_GENERATION:
            return "TruAudience Identity provides consumer data hygiene, enrichment and matching solutions using online and offline identifiers.";
        case ThirdPartyIdentityProvider.LIVERAMP_RAMPID_TRANSCODING:
            return `Liveramp's Transcoding API allows for translation of your RampID into another collaborator's RampID space.`;
        case ThirdPartyIdentityProvider.LIVERAMP_IDENTITY_RESOLUTION:
            return `Liveramp's Retrieval API enables translation of PII into a durable, pseudonymous RampID.`;
        case ThirdPartyIdentityProvider.LIVERAMP_IDENTITY_SOLUTION:
            return `LiveRamp's Native App enables resolution and data connectivity through its pseudonymous identifier, the RampID, available through the Snowflake Marketplace.`;
        case ThirdPartyIdentityProvider.ACXIOM_IDENTITY_GENERATION:
            return "Acxiom - Real ID lets you generate Real IDs using your personally identifiable information (PII) securely within Snowflake, without ever needing to transfer your PII outside your Snowflake account.";
        case ThirdPartyIdentityProvider.ACXIOM_TRANSCODING:
            return "Acxiom - Real ID Transcoding facilitates collaboration with your partners, affording you the ability to generate a crosswalk of your Real IDs and your business partners Real IDs, without ever needing to transfer your PII outside your Snowflake account.";
        case ThirdPartyIdentityProvider.GOOGLE_PAIR_DV360:
            return "PAIR is a secure and privacy-forward way for enabling advertisers and publishers to reconcile their first-party data for marketing use cases. By enabling, you will specify your join policies which will automatically be encrypted using PAIRs encryption protocol.";
        case ThirdPartyIdentityProvider.MERKURY_IDENTITY_GENERATION:
            return "dentsu's Merkury Identity Connector enables collaboration across Merkury IDs and the translation of select personally identifiable information (PII) into a pseudonymized Merkury ID securely within snowflake.";
        case ThirdPartyIdentityProvider.UID_2:
            return "An identity fabric for the open internet, Unified ID 2.0 (UID2) provides privacy-conscious holistic targeting and measurement across devices.";
        default:
            return;
    }
}

export enum KeyboardEventKey {
    Escape = "Escape",
    Enter = "Enter",
    Space = " ",
}

export const ROLE_TYPE = {
    DATA_PROVIDER: "data_provider",
    RUN_ANALYSIS: "run_analysis",
};

export const RoleOptions = [
    { value: ROLE_TYPE.DATA_PROVIDER, label: "Data provider only" },
    { value: ROLE_TYPE.RUN_ANALYSIS, label: "Run analysis & query" },
];

export const APPLICATION_TAG_TYPE_MESSAGE = {
    BETA: {
        title: "Beta",
        description:
            "This advanced feature enables collaborators to run free-form SQL while adhering to the privacy constraints of columns in the table. This is a complex feature provided in Beta to give you an early preview. Please be aware while you use it; we welcome your feedback.",
    },
    NEW: {
        title: "New",
    },
};

// below data is used to provide right name of regions in add collaborators modal

// The IDs below come from the following configuration file: https://github.com/snowflake-eng/snapps-configs/blob/dev/base/common/numeracy/gds-dump-configmap.yaml

export const CLOUD_PROVIDERS_MAPPING = {
    AWS: {
        name: "Amazon Web Services",
        icon: "static/images/icons/_aws.svg",
        regions: [
            {
                name: "US West (Oregon)",
                id: "preprod8.us-west-2",
            },
            {
                name: "US West (Oregon)",
                id: "us-west-2",
            },
            {
                name: "US East (Ohio)",
                id: "us-east-2",
            },
            {
                name: "US East (N. Virginia)",
                id: "us-east-1",
            },
            {
                name: "Canada (Central)",
                id: "ca-central-1",
            },
            {
                name: "South America (Sao Paulo)",
                id: "sa-east-1",
            },
            {
                name: "Africa (Cape Town)",
                id: "af-south-1",
            },
            {
                name: "EU (Ireland)",
                id: "eu-west-1",
            },
            {
                name: "Europe (London)",
                id: "eu-west-2",
            },
            {
                name: "EU (Paris)",
                id: "eu-west-3",
            },
            {
                name: "EU (Frankfurt)",
                id: "eu-central-1",
            },
            {
                name: "EU (Zurich)",
                id: "eu-central-2",
            },
            {
                name: "EU (Stockholm)",
                id: "eu-north-1",
            },
            {
                name: "Asia Pacific (Tokyo)",
                id: "ap-northeast-1",
            },
            {
                name: "Asia Pacific (Osaka)",
                id: "ap-northeast-3",
            },
            {
                name: "Asia Pacific (Seoul)",
                id: "ap-northeast-2",
            },
            {
                name: "Asia Pacific (Mumbai)",
                id: "ap-south-1",
            },
            {
                name: "Asia Pacific(Singapore)",
                id: "ap-southeast-1",
            },
            {
                name: "Asia Pacific (Sydney)",
                id: "ap-southeast-2",
            },
            {
                name: "Asia Pacific (Jakarta)",
                id: "ap-southeast-3",
            },
        ],
    },
    AZURE: {
        name: "Microsoft Azure",
        icon: "static/images/icons/azur_28x32.svg",
        regions: [
            {
                name: "East US 2 (Virginia)",
                id: "preprod2.east-us-2",
            },
            {
                name: "West US 2 (Washington)",
                id: "west-us-2",
            },
            {
                name: "Central US (Iowa)",
                id: "central-us",
            },
            {
                name: "South Central US (Texas)",
                id: "south-central-us",
            },
            {
                name: "East US 2 (Virginia)",
                id: "east-us-2",
            },
            {
                name: "Canada Central (Toronto)",
                id: "canada-central",
            },
            {
                name: "UK South (London)",
                id: "uk-south",
            },
            {
                name: "North Europe (Ireland)",
                id: "north-europe",
            },
            {
                name: "West Europe (Netherlands)",
                id: "west-europe",
            },
            {
                name: "Switzerland North (Zurich)",
                id: "switzerland-north",
            },
            {
                name: "Sweden Central (Gävle)",
                id: "sweden-central",
            },
            {
                name: "UAE North (Dubai)",
                id: "uae-north",
            },
            {
                name: "Central India (Pune)",
                id: "central-india",
            },
            {
                name: "Japan East (Tokyo)",
                id: "japan-east",
            },
            {
                name: "Korea Central (Seoul)",
                id: "korea-central",
            },
            {
                name: "Mexico Central (Querétaro)",
                id: "mexico-central",
            },
            {
                name: "Southeast Asia (Singapore)",
                id: "southeast-asia",
            },
            {
                name: "Australia East (New South Wales)",
                id: "australia-east",
            },
        ],
    },
    GCP: {
        name: "Google Cloud",
        icon: "static/images/icons/google_38x32.svg",
        regions: [
            {
                name: "US Central1 (Iowa)",
                id: "us-central1",
            },
            {
                name: "US East4 (N. Virginia)",
                id: "us-east4",
            },
            {
                name: "Europe West2 (London)",
                id: "europe-west2",
            },
            {
                name: "Europe West3 (Frankfurt)",
                id: "europe-west3",
            },
            {
                name: "Europe West4 (Netherlands)",
                id: "europe-west4",
            },
            {
                name: "Middle East Central2 (Dammam)",
                id: "me-central2",
            },
        ],
    },
};

export const get_csp_icon_title = (type, csp) => {
    const cloud = csp?.toUpperCase() || "";
    if (type === "csp") return CLOUD_PROVIDERS_MAPPING[cloud]?.name || "";
    if (type === "icon") return CLOUD_PROVIDERS_MAPPING[cloud]?.icon || "";
};

export const get_region = (csp, region) => {
    const cloud = csp?.toUpperCase() || "";
    const regionId = region?.toLowerCase() || "";
    const regions = CLOUD_PROVIDERS_MAPPING[cloud]?.["regions"];
    const selectedRegion = regions?.find((reg) => reg.id === regionId);
    if (selectedRegion) {
        return selectedRegion["name"];
    } else {
        return regionId;
    }
};

export const get_locator_region_csp_from_identifier = (identifier) => {
    const parts = identifier?.split(".") || [];

    if (parts.length < 3) {
        return {};
    }

    const locator = parts.shift();
    const csp = parts.pop();
    const region = parts.join(".");

    return {
        locator: locator,
        region: region,
        csp: csp,
    };
};

export const MAX_NUMBER_OF_OVERLAP_ROWS_TO_SUPPORT = 1000;

export const SEPARATOR = "~|~";
